import React, { useState } from 'react';
import axios from 'axios';
import { MARQUE } from '../marque';
import { API, setToken } from '../api';
import { T } from '../theme';

function Login({ onLogin, sessionExpiree }) {
  const [form, setForm] = useState({ email: '', mot_de_passe: '' });
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.email || !form.mot_de_passe) return setErreur('Remplissez tous les champs');
    setLoading(true);
    try {
      const response = await axios.post(`${API}/login`,
        new URLSearchParams({ username: form.email, password: form.mot_de_passe }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      setToken(response.data.access_token);
      onLogin({ id: response.data.id, nom: response.data.nom, role: response.data.role });
    } catch (e) {
      // Un `catch` unique annonçait « Email ou mot de passe incorrect » quoi
      // qu'il arrive — serveur éteint compris. On cherche alors un mot de
      // passe perdu pendant que le backend est simplement arrêté ; le quota
      // anti-force-brute, lui, ne disait jamais son nom. Chaque cause a
      // désormais son message.
      if (!e.response) {
        setErreur("Le serveur ne répond pas. Vérifiez qu'il est bien démarré.");
      } else if (e.response.status === 429) {
        setErreur(e.response.data?.detail
          || 'Trop de tentatives de connexion. Réessayez dans quelques minutes.');
      } else if (e.response.status === 401) {
        setErreur('Email ou mot de passe incorrect');
      } else {
        setErreur(`Connexion impossible (erreur ${e.response.status}).`);
      }
    }
    setLoading(false);
  };

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      height: '100vh', background: 'linear-gradient(135deg, #1a2b4a 0%, #2d4a7a 100%)',
      fontFamily: T.police
    }}>
      <div style={{
        background: 'white', padding: '48px 40px', borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', width: '380px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={MARQUE.logo} alt="" style={{ width: '100px', height: '100px', borderRadius: '50%', marginBottom: '16px' }} />
          <h1 style={{ color: '#1a2b4a', margin: '0 0 4px', fontSize: '22px', fontWeight: '600' }}>{MARQUE.nom}</h1>
          <p style={{ color: '#888', margin: 0, fontSize: '14px' }}>Connectez-vous à votre espace</p>
        </div>

        {sessionExpiree && !erreur && (
          <div style={{ background: '#fffbeb', color: '#92400e', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #fde68a' }}>
            Votre session a expiré. Merci de vous reconnecter.
          </div>
        )}

        {erreur && (
          <div style={{ background: '#fff0f0', color: '#cc0000', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #ffcccc' }}>
            {erreur}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#444' }}>Email</label>
          <input type="email" placeholder="votre@email.fr"
            autoCapitalize="none" autoCorrect="off" spellCheck={false}
            value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box', fontSize: '15px', outline: 'none' }} />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#444' }}>Mot de passe</label>
          <input type="password" placeholder="••••••••"
            value={form.mot_de_passe} onChange={e => setForm({ ...form, mot_de_passe: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box', fontSize: '15px', outline: 'none' }} />
        </div>

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: '100%', padding: '14px', background: '#1a2b4a', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', cursor: 'pointer', fontWeight: '600', letterSpacing: '0.5px' }}>
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>
      </div>
    </div>
  );
}

export default Login;